import { Button, Modal } from "antd";

export interface DuplicateNameModalProps {
  isVisible: boolean;
  onClose: () => void;
  name: string;
}

export function DuplicateNameModal({
  isVisible,
  onClose,
  name
}: DuplicateNameModalProps) {
  return (
    <Modal
      className={"create-folder-modal clean"}
      visible={isVisible}
      onCancel={() => onClose()}
    >
      <header>
        <h2>Duplicated design name</h2>
      </header>

      <p>
        You already have a design called <b>{name}</b>.<br/>
        Please choose another name.
      </p>

      <footer>
        <Button
          size={"large"}
          className={"primary"}
          onClick={onClose}
        >
          Okay
        </Button>
      </footer>
    </Modal>
  );
}
